































































import { defineComponent } from '@nuxtjs/composition-api'
import { defineComponentTranslations } from '~/utils/i18n'
import { useI18n } from '~/compositions/i18n'
import { useUserAgent } from '~/compositions/user-agent'

export default defineComponent({
  components: {},
  setup() {
    const { t } = useI18n()

    const { isMobile } = useUserAgent()

    return { t, isMobile }
  },
  i18n: defineComponentTranslations({
    tbi_bf_without_fees: {
      en: 'No administration fees worth €200',
      el: 'Χωρίς έξοδα διαχείρισης αξίας 200€'
    },
    tbi_bf_fixed_interest: {
      en: 'Fixed interest rate of 12%',
      el: 'Mε σταθερό επιτόκιο 12%'
    }
  })
})
